import React from 'react';

import {
    GlobalMetricLabels,
    GlobalMetricKeys
} from "@uw-it-sis/lib-react/lib/AppConstants";

export const PLAN_ITEM_NOTE_LIMIT = 500;

export const DateFormatString = "M/D/YYYY";
// format of calendar dates provided in notices from notices service
export const NoticesDateFormat = "MM/DD/YYYY";
// format of calendar dates provided in term academic calendar items
export const AcademicCalendarDateFormat = "YYYY-MM-DD";

export const PlanItemType = Object.freeze({
    registered: "registered",
    planned: "planned",
    backup: "backup",
    recommended: "recommended"
});

export const NextAction = Object.freeze({
    REG_SVCS_NOT_OPEN: 'reg_svcs_not_open', // Registration services haven't opened yet, for anybody
    ACKNOWLEDGE: 'acknowledge', // acknowledges need to be completed
    ADDRESS: 'address', // address verification needs to be done
    PREREG: 'prereg', // UI only state
    BLOCK: 'block', // student has a reg block
    STUDENT_REG_NOT_OPEN: 'student_reg_not_open', // This student's registration period hasn't opened yet
    REGISTER: 'register', // student is ready to register
    SUCCESS: 'success', // reg post was a success
    FAIL: 'fail' // reg post was a failure
});

/**
 * Metric label keys that can be used in analytics methods.
 *
 * The values used with these labels must be consistent otherwise it might cause cardinality issues in the Prometheus
 * database.
 *
 * NOTE: IF YOU UPDATE THIS OBJECT, UPDATE LIB-LAMBDA-MYPLAN TOO
 */
export const MetricLabels = {
    // Fold the global labels into the planning-specific labels so that both constants don't have to be imported.
    ...GlobalMetricLabels,
    /* Audit code (e.g. 0ACMS$$2015). Dollar signs will be converted to _ */
    auditCode: "audit_code",
    /* Credential Code (e.g. B BUS-0-1-2). Spaces will be converted to _ */
    credentialCode: "credential_code",
    /* Department code */
    departmentCode: "department_code",
    /* Organization code */
    organizationCode: "organization_code",
    /* Program Code */
    programCode: "program_code",
    /* Topic code */
    topicCode: "topic_code",
    /* The term id (e.g. 20231) */
    quarter: "quarter",
    /* The name of the group of facet values (e.g. credits, level, term) */
    facetName: "facet_name",
    /* Search autosuggest selection of subject area or gened or instructor */
    grouping: "grouping",
};

/**
 * Metrics keys. The go into the metric_key label in Prometheus.
 */
export const MetricKeys = {
    ...GlobalMetricKeys,
    facetInteraction: "facet-interaction"
}

export const MYPLAN_GEN_ED_ANNOUNCE = {
    id: "myplan_gen_ed_announce",
    start: "2022-09-08",
    end: "2023-03-26",
    title: "General Education Requirement Update",
    message: <>
        <p>Areas of Knowledge (AoK) are changing to Areas of Inquiry (AoI). Please refer to
            the <a href="https://www.washington.edu/uaa/advising/degree-overview/general-education/general-education-1-1/" target="_blank">Undergraduate Advising site</a> for
            more information on this update.</p>
        <table className="mx-auto" style={{borderCollapse: 'separate', borderSpacing: '0 1rem'}}>
            <thead className="sr-only">
                <tr>
                    <th>Old Name</th>
                    <th aria-hidden={true}></th>
                    <th>New Name</th>
                </tr>
            </thead>
            <tbody className="fw-bold">
                <tr className="bg-gray-light">
                    <td className="text-center ps-3 pe-2">Visual, Literary &amp; Performing Arts (VLPA)</td>
                    <td className="text-center px-2">&gt;</td>
                    <td className="text-center ps-2 pe-3">Arts and Humanities (A&amp;H)</td>
                </tr>
                <tr className="bg-gray-light">
                    <td className="text-center ps-3 pe-2">Individuals &amp; Societies (I&amp;S)</td>
                    <td className="text-center px-2">&gt;</td>
                    <td className="text-center ps-2 pe-3">Social Sciences (SSc)</td>
                </tr>
                <tr  className="bg-gray-light">
                    <td className="text-center ps-3 pe-2">Natural World (NW)</td>
                    <td className="text-center px-2">&gt;</td>
                    <td className="text-center ps-2 pe-3">Natural Sciences (NSc)</td>
                </tr>
                <tr  className="bg-gray-light">
                    <td className="text-center ps-3 pe-2">Quantitative and Symbolic Reasoning (QSR)</td>
                    <td className="text-center px-2">&gt;</td>
                    <td className="text-center ps-2 pe-3">Reasoning (RSN)</td>
                </tr>
            </tbody>
        </table>
    </>
};